import React from 'react'

/**
 * Shared dashboard color scale.
 * Edit the hex values here to update colors everywhere:
 * KPI cards, cohort matrix cells, and breakdown table percentage cells.
 */

export const DASHBOARD_SCALE = [
  {min: 75, bg: '#1bc5bd', text: '#fff'},  // green  (≥75%)
  {min: 50, bg: '#ffa800', text: '#fff'},  // amber  (≥50%)
  {min:  1, bg: '#f64e60', text: '#fff'},  // red    (<50%)
] as const

/** Higher is better (cohort retention %, renovations %) */
export function retentionStyle(pct: number): React.CSSProperties | undefined {
  const tier = DASHBOARD_SCALE.find((t) => pct >= t.min)
  return tier ? {backgroundColor: tier.bg, color: tier.text} : undefined
}

/** Lower is better (churn rate %, cancellations %) */
export function inverseStyle(pct: number): React.CSSProperties {
  if (pct <= 10) return {backgroundColor: '#1bc5bd', color: '#fff'}
  if (pct <= 20) return {backgroundColor: '#ffa800', color: '#fff'}
  return {backgroundColor: '#f64e60', color: '#fff'}
}

/** Text-only variant — same scale but colors the text instead of the background */
export function retentionTextColor(pct: number): string {
  const tier = DASHBOARD_SCALE.find((t) => pct >= t.min)
  return tier ? tier.bg : '#a1a5b7'
}

export function inverseTextColor(pct: number): string {
  if (pct <= 10) return '#1bc5bd'
  if (pct <= 20) return '#ffa800'
  return '#f64e60'
}


export function renovationTextColor(pct: number): string {
  if (pct > 20)  return '#1bc5bd'
  if (pct > 5) return '#ffa800'
  return '#f64e60'
}
